module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-592.5adf190.woff2";